import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {LazyPanel} from '@Components/lazy-panel';
import type {PosterItemsListPanelProps} from '@Panels/poster-items-list-panel/poster-items-list-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'poster-items-list-modal-panel';

export type PosterItemsListModalProps = PosterItemsListPanelProps;

export default function PosterItemsListModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.POSTER_ITEMS_LIST_MODAL];
  });

  const height = '100%';
  const width = '100%';

  return (
    <Modal modalId={MODALS_IDS.POSTER_ITEMS_LIST_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="poster-items-list-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterItemsListModal = (props: PosterItemsListPanelProps = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_ITEMS_LIST_MODAL,
      panelProps: props,
    })
  );
};
